<template>
  <div data-test="information-card-players" class="information-card-players">
    <InformationCard
      heading="Player Information"
      :read-only="readOnly"
      @edit="$emit('edit')"
    >
      <div class="information-card-players__info-container body--p1--regular">
        <template v-for="(player, index) in players" :key="index">
          <p class="information-card-players__info-column1">
            {{ player.name }}
          </p>
          <p class="information-card-players__info-column2">
            {{ player.email }}
          </p>
        </template>
      </div>
    </InformationCard>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import InformationCard from '@base/components/InformationCard/InformationCard.vue'
import { Player } from './PlayerType'

export default defineComponent({
  name: 'InformationCardPlayers',
  components: { InformationCard },
  props: {
    players: {
      type: Array as PropType<Player[]>,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit']
})
</script>

<style lang="scss" scoped>
.information-card-players {
  &__info-container {
    column-gap: var(--spacing--6);
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    row-gap: var(--spacing--8);
  }
}
</style>
